<template>
    <header>
        <h1>slideshow.builders</h1>
        <div class="loginBox">
            <button @click="showAboutModal=true">About</button>
            <template v-if="$store.state.user.status.name=='resolved'">
                {{$store.state.user.data.email}}
                <button @click="logout()">Logout</button>
            </template>
            <template v-if="$store.state.user.status.name=='rejected'">
            <button @click="showLoginModal=true">Login</button>
            </template>
        </div>
    </header>
<!--    <buy></buy>-->
    <presentation-generator @show-login-modal="showLoginModal=true"/>
    <login-modal v-if="showLoginModal" @close="showLoginModal = false"/>
    <about-modal v-if="showAboutModal" @close="showAboutModal = false"/>
<!--    <credits-history/>-->
<!--    <footer><a href="https://interactivecrew.io">Made by Interactive Crew</a> </footer>-->
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import LoginModal from "@/Account/components/LoginModal.vue";
import PresentationGenerator from "@/Presentation/PresentationGenerator.vue";
import Buy from "@/Credit/Buy.vue";
import CreditsHistory from "@/Credit/CreditsHistory.vue";
import AboutModal from "@/Common/components/AboutModal.vue";


export default {
    name: 'App',
    components: {
        AboutModal,
        CreditsHistory,
        Buy,
        PresentationGenerator,
        HelloWorld,
        LoginModal
    },
    data() {
        return {
            showLoginModal: false,
            showAboutModal:false
        }
    },
    mounted() {
        this.$store.dispatch('checkLogin')
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    },
    watch: {
        showLoginModal(val) {
            window.gtag('event','showLoginModal', {val})
        },
        showAboutModal(val) {
            window.gtag('event','showAboutModal', {val})
        }
    }
}
</script>

<style lang="scss">
@import "./Common/scss/index.scss";
</style>
